import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

import { fetchP24TransactionDataByP24 } from "../../actions/p24TransactionActions";

import { formatMoneyDiv100 } from "../../helpers/utils";

class P24TransactionDataByP24 extends React.Component {

    componentDidMount() {

        this.props.fetchP24TransactionDataByP24(this.props.transaction.id);
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.onSubmit();
    };


    render() {

        return (
            <div className="w3-card-4" >
                <div className="w3-container w3-theme">
                    <h2 className="w3-center">Dane transakcji w systemie P24</h2>
                </div>

                <div className="w3-container w3-theme-l3">
                    <h5 className="w3-center">Dane transakcyjne</h5>
                </div>

                <div className="w3-row-padding">

                    <div className="w3-col s6">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.statement}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.statement"
                                defaultMessage="statement"
                            />
                        </label>
                    </div>

                    <div className="w3-col s2">
                        &nbsp;
                    </div>

                    <div className="w3-col s2">
                        <span className="w3-input w3-right-align" style={{ height: '39px' }}>
                            {formatMoneyDiv100(this.props.p24TransactionDataByP24.amount)}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.amount"
                                defaultMessage="Amount"
                            />
                        </label>
                    </div>
                    <div className="w3-col s2">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.currency}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.currency"
                                defaultMessage="currency"
                            />
                        </label>
                    </div>

                </div>

                <div className="w3-row-padding">



                    <div className="w3-col s6">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.description}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.description"
                                defaultMessage="description"
                            />
                        </label>
                    </div>

                    <div className="w3-col s2">
                        &nbsp;
                    </div>

                    <div className="w3-col s2">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.paymentMethod}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.paymentMethod"
                                defaultMessage="paymentMethod"
                            />
                        </label>
                    </div>

                    <div className="w3-col s2">
                        <img src={`https://static.przelewy24.pl/payment-form-logo/svg/${this.props.p24TransactionDataByP24.paymentMethod}`} alt="payment method" style={{ height: '39px' }} />
                    </div>


                </div>

                <div className="w3-row-padding">

                    <div className="w3-col s4">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.date}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.date"
                                defaultMessage="date"
                            />
                        </label>
                    </div>

                    <div className="w3-col s2">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.fee}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.fee"
                                defaultMessage="fee"
                            />
                        </label>
                    </div>

                    <div className="w3-col s2">
                        &nbsp;
                    </div>



                    <div className="w3-col s4">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.dateOfTransaction}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.dateOfTransaction"
                                defaultMessage="dateOfTransaction"
                            />
                        </label>
                    </div>

                </div>

                <div className="w3-container w3-theme-l3">
                    <h5 className="w3-center">Dane identyfikacyjne</h5>
                </div>

                <div className="w3-row-padding">

                    <div className="w3-col s4">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.sessionId}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.sessionId"
                                defaultMessage="sessionId"
                            />
                        </label>
                    </div>

                    <div className="w3-col s4">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.orderId}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.orderId"
                                defaultMessage="orderId"
                            />
                        </label>
                    </div>

                    <div className="w3-col s2">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.batchId}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.batchId"
                                defaultMessage="batchId"
                            />
                        </label>
                    </div>

                    <div className="w3-col s2">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.status}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.status"
                                defaultMessage="status"
                            />
                        </label>
                    </div>

                </div>

                <div className="w3-row-padding">

                    <div className="w3-col s6">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.accountMD5}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.accountMD5"
                                defaultMessage="accountMD5"
                            />
                        </label>
                    </div>

                </div>

                <div className="w3-container w3-theme-l3">
                    <h5 className="w3-center">Dane klienta</h5>
                </div>

                <div className="w3-row-padding">

                    <div className="w3-col s6">
                        <span
                            className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.clientEmail}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.clientEmail"
                                defaultMessage="clientEmail"
                            />
                        </label>
                    </div>

                    <div className="w3-col s6">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.clientName}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.clientName"
                                defaultMessage="clientName"
                            />
                        </label>
                    </div>
                </div>

                <div className="w3-row-padding">

                    <div className="w3-col s6">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.clientAddress}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.clientAddress"
                                defaultMessage="clientAddress"
                            />
                        </label>
                    </div>

                    <div className="w3-col s3">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.clientPostcode}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.clientPostcode"
                                defaultMessage="clientPostcode"
                            />
                        </label>
                    </div>

                    <div className="w3-col s3">
                        <span className="w3-input" style={{ height: '39px' }}>
                            {this.props.p24TransactionDataByP24.clientCity}
                        </span>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24TransactionDataByP24.clientCity"
                                defaultMessage="clientCity"
                            />
                        </label>
                    </div>
                </div>

                <form className="w3-container" onSubmit={this.handleSubmit}>

                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                            type="submit"
                        >
                            Zamknij
                        </button>
                    </div>
                </form>
            </div>
        )
    }

}

P24TransactionDataByP24.propTypes = {
    //dane wejsciowe obiektu do wypelnienia
    transaction: PropTypes.object.isRequired,
    //akcja zwrotna na zatwierdzenie
    onSubmit: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    p24TransactionDataByP24: state.p24TransactionReducer.p24TransactionDataByP24
});

const mapDispatchToProps = ({
    fetchP24TransactionDataByP24: fetchP24TransactionDataByP24
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(P24TransactionDataByP24);